import { useEffect, useState } from "react";
import axios from "axios";

import styles from "../../common/Page.module.css";
import PhotoBoardPreview from "Page/common/PhotoBoardPreview";

export default function PortfolioMain() {
  let [data, setData] = useState([]);

  return (
    <div className={styles.Main}>
      <PhotoBoardPreview
        title="제품 납품"
        api="portfolio"
        to="portfolio/delivery"
        category_id="8"
        forceTo="delivery"
      />
      <PhotoBoardPreview
        title="외주 현황"
        api="portfolio"
        to="portfolio/outsourcing"
        category_id="9"
        forceTo="outsourcing"
      />
    </div>
  );
}
